import React from 'react';
import ValidationFlow from './ValidationFlow';

const VigilanceValidation = () => {
  return (
    <ValidationFlow
      validationType="user"
      title="Vigilance Validation"
      subtitle="Verify your identity to access the vigilance portal"
      redirectPath="/vigilance-login"
      backPath="/vigilance-login"
      showBackToHome={false}
    />
  );
};

export default VigilanceValidation;